import { gql } from '@apollo/client';

export const GET_CONTRACT_LINE_HISTORY = gql`
  query getContractLineHistory($contractLineId: Float!) {
    getContractLineHistory(contractLineId: $contractLineId) {
      id
      versionNumber
      modTag
      contractHeaderVersionId
      contractHeaderVersion {
        versionNumber
      }
      createdBy
      createdByUser {
        fullName
        email
      }
      createdAt
      changes
      versionUpdates {
        id
        changes
        createdBy
        createdAt
        createdByUser {
          fullName
          email
        }
      }
    }
  }
`;

export const GET_CONTRACT_LINE_BY_ID = gql`
  query getContractLineById($contractLineId: Float!) {
    getContractLineById(contractLineId: $contractLineId) {
      id
      scheduleLine
      modelYear
      contractLineRenewals {
        id
        contractHeaderId
        contractHeader {
          contractHeaderId
          contractYear
          renewalYear
        }
      }
      contractLineVersions {
        id
        versionNumber
      }
      contractHeader {
        contractHeaderId
        contractNumber
        contractYear
        renewalYear
        fleetAwarded
        publishedInFleet
        contractUpiid
        contractEndDate
        solicitationId
        solicitation {
          purchaseTypeCode
          contractYear
          solicitationNumber
          solicitationNumberLegacy
        }
        solicitationPeriodId
        solicitationPeriod {
          periodType
          contractPeriod
        }
        vendor {
          id
          vendorName
          uniqueEntityIdentifier
        }
      }
      standardItemId
      standardItem {
        standardItemId: id
        standardItemNumber
        title
        year
      }
      make {
        makeName
        makeCode
        nhtsaStatus
        fleetStatus
      }
      model {
        modelName
        modelCode
        nhtsaStatus
        fleetStatus
      }
      chassisMake {
        makeName
        makeCode
        nhtsaStatus
        fleetStatus
      }
      chassisModel {
        modelName
        modelCode
        nhtsaStatus
        fleetStatus
      }
      makeModelApproval {
        fleetApprovalStatus
      }
    }
  }
`;
